import { useFormikContext } from 'formik';
import { ChangeEvent } from 'react';
import * as React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { FormikTextBox } from '../../../../../commonInfra/components/FormikField';
import { disabledText, formError, narrowTextFieldStyle } from '../../../../styles/CommonStyles';
import { RevisionHistorySectionProps } from './RevisionHistorySection';
import { RevisionHistoryBusinessLogic } from './RevisionInputBusinessLogic';
import useDebouncedExcessRevisionsMessageUpdater = RevisionHistoryBusinessLogic.useDebouncedExcessRevisionsMessageUpdater;
import useRevisionsValidator = RevisionHistoryBusinessLogic.useRevisionsValidator;

export const CONTENT_VERSION_LIMIT_FIELD = 'settings.contentVersionLimit';
const REVISIONS_LABEL_ID = 'content-version-limit-label-span';

export function RevisionsInput(props: RevisionHistorySectionProps) {
  const formik = useFormikContext<RevisionHistorySectionProps>();
  const [excessRevisionsMessage, setExcessRevisionsMessage] = React.useState('');
  const excessMessageUpdater = useDebouncedExcessRevisionsMessageUpdater(setExcessRevisionsMessage);

  const disabled = !formik.values.settings.contentVersionLimitEnabled;
  const validate = useRevisionsValidator(disabled);

  const limit = formik.values.settings.contentVersionLimit;
  React.useEffect(() => {
    if (!props.hideRevisionHistoryLimitWarning) {
      setExcessRevisionsMessage('');
      excessMessageUpdater(limit);
    }
  }, [props.hideRevisionHistoryLimitWarning, excessMessageUpdater, limit]);

  const changeHandler = React.useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    formik.setFieldTouched(CONTENT_VERSION_LIMIT_FIELD, true);
    formik.setFieldValue(CONTENT_VERSION_LIMIT_FIELD, value !== '' && !isNaN(+value) ? +value : value);
  }, [formik.setFieldValue, formik.setFieldTouched]);

  return <>
    <div>
      <FormikTextBox name={CONTENT_VERSION_LIMIT_FIELD}
                     disabled={disabled}
                     label={null}
                     className={narrowTextFieldStyle}
                     aria-labelledby={REVISIONS_LABEL_ID}
                     testId={'version-limit-input'}
                     showValidationMessage={false}
                     eagerValidation={true}
                     onChange={changeHandler}
                     validate={validate}/>
      &nbsp; <label id={REVISIONS_LABEL_ID} className={disabled ? disabledText : undefined}>
        {Messages.contentVersionLimitTextInputLabel()}
      </label>
    </div>

    {
      formik.errors?.settings?.contentVersionLimit
      && formik.touched.settings?.contentVersionLimit
      && <div className={formError} data-tb-test-id={'revision-limit-invalid-number-error'}>
      {formik.errors.settings.contentVersionLimit}
    </div>
    }

    {
      !formik.errors?.settings?.contentVersionLimit
      && !disabled
      && formik.touched.settings?.contentVersionLimit
      && excessRevisionsMessage
      && <div className={formError} data-tb-test-id={'revision-limit-will-delete-warning'}>
        {excessRevisionsMessage}
      </div>
    }
  </>;
}
